/**
 * orga-app-api - incidents-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface IncidentsFunktionsbereichAbteilungRequest { 
    bezeichnung?: string;
    ist_aktiv: boolean;
    rufnummer?: string;
    zentrale_darf_delegieren: boolean;
    funktionsbereich_id: string;
}

